import axios from 'axios';
import cache, { del as delCache } from '@/helpers/cache';
import { Order } from '@/models/order';
import PackageHelper, { Package } from '@/models/package';
import { Coupon } from '@/models/coupon';
import { Pagination } from '@/models/pagination';
import { View } from '@/models/view';
import { DataReq } from '@/components/Pivot/views/view';
import { SaveDataFile } from '@/helpers/SaveDataFile';
import { Bundle } from '@/models/bundle';
import { Permission } from '@/models/permission';
import { ServiceMatrix, ServiceMatrixUser } from '@/models/serviceMatrix';

const BASE_URL = 'https://licenses-api.hearxgroup.com';

// auth http client using firebase token
const axAuth = axios.create({
  // baseURL: BASE_URL,
  baseURL: process.env.VUE_APP_API_BASE_URL,
  withCredentials: true,

  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  }
});

const dataOnly = (v: any) => v.data;//.data;

export interface PivotReq {
  filter: any;
}

export default {
  http: axAuth,

  setToken(token: string) {
    this.http.defaults.headers.Authorization = 'token ' + token;
  },

  async getAccountLicenses(accountID: number) {
    const key = `/admin/licensing/admin/v1/account/${accountID}/licenses`;
    return dataOnly(
      await cache(key, 60 * 5, () => this.http.get(`/admin/licensing/admin/v1/account/${accountID}/licenses`)),
    ).licenses as License[];
  },
};

export interface License {
  id:              string;
  type:            string;
  credits:         string;
  frequency:       string;
  active:          boolean;
  track_credits:   boolean;
  subscription_id: string;
  device_id:       string;
  account_id:      string;
  previous_credit: string;
  next_credit:     string;
  expires:         string;
}


